
<t-prefix>
  <label :for="`bulk_checkbox_${entry.id}`" class="sr-only">Select record for bulk action</label>
  <input
    ref="checkbox" type="checkbox" v-on:input="selectEntry()" :checked="isSelectedEntry" :id="`bulk_checkbox_${entry.id}`">
</t-prefix>
